<template>
  <div class="main">
    <PageHeader title="同行" class="list whitespace-nowrap">
      <template #title-header-content>
        <div class="pl-2 flex ml-6 justify-end flex-1 items-center">
          <!-- 切替 -->
          <div class="bg-white rounded mr-5">
            <div class="flex items-center py-1 rounded mx-5 ">
              <div v-for="t in tabList" 
                :key="'tab' + t.id"
                class="w-28 text-center mx-1 cursor-pointer"
                :class="[tabNo == t.id ? 'bg-light-blue-700' : 'hover:bg-gray-400', 'bg-gray-300 rounded-md py-1 text-sm font-medium text-white']" 
                @click="changeTab(t.id)"
              >
                {{ t.name }}
              </div>
            </div>
          </div>

          <PrimaryButton
            v-if="[2, 3].includes(tabNo)"
            text="検索"
            class="flex button-contents whitespace-nowrap"
            @click="getData()"
            :buttonContents="'要'"
          >
          </PrimaryButton>

          <!-- 名前絞込み -->
          <PrimaryButton
            v-if="[2, 3].includes(tabNo)"
            v-tooltip="'自分のデータのみ'"
            :text="isMobileDevice||isTabletDevice?'自分のデータ':''"
            :buttonContents="'要'"
            class="ml-2"
            :class="[filter.filterUpdateUser ? 'clickButtonColor2' : 'normalButtonColor', isMobileDevice||isTabletDevice?'px-1':'']"
            @click="filter.filterUpdateUser=!filter.filterUpdateUser"
          >
            <Icon v-if="!isMobileDevice&&!isTabletDevice" slot="before" iconName="User" iconType="solid" :strokeWidth="2" class="h-5 w-5 " />
          </PrimaryButton>

          <h1 class="text-lg font-bold text-white flex items-center ml-2 whitespace-nowrap">
            <Icon iconName="" class="w-7 h-7 mr-2" /> <span class="mt-0 ">{{ list.length }} 件</span>
          </h1>

          <Icon 
            iconName="Refresh" 
            :clickable="false" 
            :class="{'animate-spin': loading}" 
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="refresh"
          />
        </div>
      </template>
      <template #page-header-content>
        <div class="flex justify-end">
          <div class="text-sm font-bold text-white mr-auto w-fit self-center">対象：ラウンド管理部</div>
          <!-- 保存ボタン -->
          <PrimaryButton v-if="[1, 4].includes(tabNo)" text="保存" size="sm" class="px-32 bg-green-600" @click="save()" />

          <!-- 検索 -->
          <div v-else-if="tabNo==2" class="flex items-stretch">
            <div class="ml-2 mr-2">
              <input
                type="search"
                name="filterNo" 
                placeholder="報告書No 検索"
                class="px-1 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 w-36" 
                v-model="filter.id"
              /> 
            </div>

            <div class="mr-2">
              <input
                type="search"
                name="filterSite" 
                placeholder="得意先or物件名 検索"
                class="px-1 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 w-36" 
                v-model="filter.clientAndSite"
              /> 
            </div>

            <div class="mr-2">
              <input
                type="search"
                name="filterUser" 
                placeholder="担当者 検索"
                class="px-1 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 w-36" 
                v-model="filter.user"
              /> 
            </div>

            <div class="mr-2">
              <input
                type="search"
                name="filterNewcomer" 
                placeholder="対象者(新人) 検索"
                class="px-1 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 w-36" 
                v-model="filter.newcomer"
              /> 
            </div>

            <div class="mr-2 -mt-4">
              <div class="text-white text-xs">予定日</div>
              <div class="flex">  
                <input
                  type="date"
                  v-model="filter.periodScheduled"
                  class="rounded border-gray-300 mr-2 text-sm"
                >
                <div class="text-white font-bold self-center text-sm whitespace-nowrap">以降を表示</div>
              </div>
            </div>
          </div>
          
          <!-- 検索 -->
          <div v-else-if="tabNo==3" class="flex items-stretch">
            <div class="mr-2">
              <input
                type="search"
                name="filterUser" 
                placeholder="対象者（新人） 検索"
                class="px-1 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900" 
                v-model="filter.user2"
              /> 
            </div>
            <div class="text-sm font-bold text-white mx-3 self-center">※対象者（新人）のみ表示</div>
          </div>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-24 w-screen bottom-4 mt-5">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">

          <div v-if="loading" class="w-full h-full flex justify-center items-center">
            <p class="text-gray-400 font-bold animate-pulse">Searching...</p>
          </div>

          <div v-else>
            <div class="overflow-hidden rounded main-height">
              <!-- 予定組 -->
              <div v-if="tabNo==1" class="py-3 px-5">
                <div>
                  <div class="font-bold text-blue-700">ノルマ：1人につき{{goal}}回<span class="font-normal">（目安：入社2ヶ月まで3回、入社3ヶ月まで2回、それ以降は1回/月）</span></div>
                  <div class="font-bold text-red-700 mt-2">表示されていない新入社員は、評価シートに入社日を入力したか本人にご確認ください。</div>
                  <div class="font-bold text-red-700 mt-2">予定日・同行者 の両方選択済みのデータのみ保存します。</div>
                  <div class="font-bold text-red-700 mt-2">同行メインタスクも自動登録されます。</div>
                  <div class="text-gray-700 text-sm mt-2">※予定を作成できるのはグループ4以上のユーザーです。</div>
                  <!-- イレギュラーボタン -->
                  <div class="mt-5">
                    <PrimaryButton text="新入社員以外の同行予定を作成" size="sm" class="" @click="irregFlg=!irregFlg"></PrimaryButton>
                    <div v-if="irregFlg" class="border border-indigo-600 rounded p-3 flex w-fit min-w-600px">
                      <div>
                        <!-- 部署選択 -->
                        <div>
                          <div class="text-xs font-bold text-gray-700 mb-1">対象者の部署を選択してください</div>
                          <select
                            name="department"
                            v-model="irreg.departmentId"
                            @change="changeDepartment()"
                            class="focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded text-xs"
                          >
                            <option
                              v-for="dep in departmentList" :key='dep.id'
                              :value="dep.departmentId"
                              class="bg-white">
                              {{ dep.name }}
                            </option>
                          </select>
                        </div>
                        <!-- 対象者 -->
                        <div v-if="irreg.staffList && irreg.staffList.length">
                          <div class="text-xs font-bold text-gray-700 mt-3 mb-1">対象者</div>
                          <WmsSuggestInput
                            name="staffirreg"
                            displayField="userName"
                            :clearable="true"
                            :dynamic="false"
                            :incrementalSearch="false"
                            :selectionItems="irreg.staffList"
                            v-model="irreg.userName"
                            class="text-sm w-fit font-bold selecter"
                            @selected="irregStaffSelected($event)"
                          />
                        </div>
                        <!-- 休みの曜日 -->
                        <div class="text-yellow-700 font-bold mt-3" v-if="irreg.holidayWeeks&&irreg.holidayWeeks.length">
                          {{ getWeek(irreg.holidayWeeks) }}
                        </div>
                      </div>
                      <!-- 予定 -->
                      <div class="ml-4">
                        <!-- 追加ボタン -->
                        <PrimaryButton v-if="irreg.userId" text="追加" size="sm" class="w-fit ml-auto block" @click="irregAddDay()">
                          <Icon iconName="PlusCircle" slot="before" class="h-4 w-4" />
                        </PrimaryButton>
                        <div v-if="irreg.schedule&&irreg.schedule.length">
                          <div v-for="(s, i) in irreg.schedule" :key="'irreg'+i" class="flex my-2 items-stretch">
                            <!-- 予定日 -->
                            <div>
                              <div class="text-xs font-bold text-gray-500 mb-1">
                                予定日
                                <span class="text-red-700" v-if="s.err">※出勤曜日でない</span>
                              </div>
                              <input
                                type="date"
                                :min="today"
                                v-model="s.day"
                                class="rounded border-gray-300 mr-2 text-sm min-w-150"
                                :class="s.err?'bg-red-100':''"
                                @change="changeDay(irreg.userName, irreg.holidayWeeks, s)"
                              >
                            </div>

                            <!-- 同行者 -->
                            <div>
                              <WmsSuggestInput
                                caption="同行者"
                                captionColor="text-gray-500"
                                :name="'irreg'+i"
                                displayField="userName"
                                :clearable="true"
                                :dynamic="false"
                                :incrementalSearch="false"
                                :selectionItems="irreg.staffList2"
                                v-model="s.senior"
                                class="text-sm selecter"
                                @selected="staffSelected($event, s, irreg)"
                              />
                            </div>

                            <!-- 備考 -->
                            <div class="mx-2">
                              <WmsSuggestInput
                                caption="備考"
                                captionColor="text-gray-500"
                                :name="'area'+i"
                                displayField="val"
                                :clearable="true"
                                :dynamic="false"
                                :incrementalSearch="false"
                                :selectionItems="noteList"
                                v-model="s.note"
                                class="text-sm selecter"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- 未完了の予定 -->
                      <div v-if="irreg.userId" class="ml-4 border rounded p-2 border-blue-300 bg-blue-50">
                        <div class="font-bold text-xs mb-3">保存済みの予定</div>
                        <div v-if="!irreg.saved||!irreg.saved.length" class="font-bold text-sm text-gray-500">なし</div>
                        <div v-for="(s, j) in irreg.saved" :key="'irregsave'+j" class="my-2 text-sm">
                          <div class="flex">
                            <!-- 予定日 -->
                            <div>
                              {{ s.day }}
                            </div>
                            <!-- 同行者 -->
                            <div class="ml-2">
                              {{ s.senior }}
                            </div>
                            <!-- 削除 -->
                            <div v-if="s.edit" @click="deleteIrregSavedRow(s, j)" class="ml-3">
                              <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" />
                            </div>
                          </div>
                          <div class="text-blue-700 mt-1 text-xs font-bold w-fit ml-auto mr-8 mb-2" v-if="s.note">
                            {{ s.note }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="list&&list.length">
                  <div class="flex flex-wrap mt-5">
                    <div v-for="(row, i) in list" :key="'sch'+i" class="py-3">
                      <div class="mb-2 flex items-end">
                        <!-- 新人さん -->
                        <div>
                          <div class="text-xs text-gray-700">入社日：{{ row.startDate }}</div>
                          <div class="font-bold mr-5">{{ row.userName }}</div>
                          <div class="">あと {{ goal - row.saved.length }} 回</div>
                        </div>
                        <!-- 休みの曜日 -->
                        <div class="text-yellow-700 font-bold" v-if="row.holidayWeeks&&row.holidayWeeks.length">
                          {{ getWeek(row.holidayWeeks) }}
                        </div>
                        <!-- 追加ボタン -->
                        <PrimaryButton text="追加" size="sm" class="ml-auto mr-10" @click="addDay(row)">
                          <Icon iconName="PlusCircle" slot="before" class="h-4 w-4" />
                        </PrimaryButton>
                        <!-- 対象外ボタン -->
                        <!-- <PrimaryButton text="対象外" size="sm" class="bg-red-600" @click="setNA(row, i)"/> -->
                      </div>
                      <div class="flex items-stretch">
                        <!-- 未予定 -->
                        <div v-if="row.schedule">
                          <div v-for="(s, j) in row.schedule" :key="'j'+j" class="flex my-2">
                            <!-- 予定日 -->
                            <div>
                              <div class="text-xs font-bold text-gray-500 mb-1">
                                予定日
                                <span class="text-red-700" v-if="s.err">※出勤曜日でない</span>
                              </div>  
                              <input
                                type="date"
                                :min="today"
                                v-model="s.day"
                                class="rounded border-gray-300 mr-2 text-sm min-w-150"
                                :class="s.err?'bg-red-100':''"
                                @change="changeDay(row.userName, row.holidayWeeks, s)"
                              >
                            </div>
                            
                            <!-- 同行者 -->
                            <div>
                              <WmsSuggestInput
                                caption="同行者"
                                captionColor="text-gray-500"
                                :name="'staff'+i+j"
                                displayField="userName"
                                :clearable="true"
                                :dynamic="false"
                                :incrementalSearch="false"
                                :selectionItems="row.staffList"
                                v-model="s.senior"
                                class="text-sm py-0 selecter"
                                @selected="staffSelected($event, s, row)"
                                @change="staffChange(s)"
                              />
                            </div>

                            <!-- 備考 -->
                            <div class="mx-2">
                              <WmsSuggestInput
                                caption="備考"
                                captionColor="text-gray-500"
                                :name="'area'+i"
                                displayField="val"
                                :clearable="true"
                                :dynamic="false"
                                :incrementalSearch="false"
                                :selectionItems="noteList"
                                v-model="s.note"
                                class="text-sm selecter"
                              />
                            </div>
                          </div>
                        </div>
                        <!-- 予定済み -->
                        <div v-if="row.saved" class="ml-5 mr-10 border rounded p-2 border-blue-300 bg-blue-50">
                          <div class="font-bold text-xs mb-3">保存済み予定</div>
                          <div v-for="(s, j) in row.saved" :key="'jj'+j" class="my-2 text-sm">
                            <div class="flex">
                              <!-- 予定日 -->
                              <div>
                                {{ s.day }}
                              </div>
                              <!-- 同行者 -->
                              <div class="ml-2">
                                {{ s.senior }}
                              </div>
                              <!-- 削除 -->
                              <div v-if="s.edit" @click="deleteRow(s, j, row)" class="ml-3">
                                <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" />
                              </div>
                            </div>
                            <div class="text-blue-700 mt-1 text-xs font-bold w-fit ml-auto mr-8 mb-2" v-if="s.note">
                              {{ s.note }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 一覧 -->
              <div v-else-if="tabNo==2">
                <div v-if="list.length" class="rounded-md border border-gray-200 table-h overflow-auto ">
                  <table class="table text-sm w-full">
                    <thead class="th sticky top-0 z-20 bg-colu">
                      <tr class="text-gray-500 text-xs border border-gray-200 bg-colu">
                        <th class="text-left p-2 whitespace-nowrap">報告書No.</th>
                        <th class="text-left p-2">予定日</th>
                        <th class="text-left p-2">担当者</th>
                        <th class="text-left p-2">同行対象者（新人）</th>
                        <th class="text-left p-2 whitespace-nowrap">得意先名<br>物件名</th>
                        <th class="text-left p-2">備考</th>
                        <th class="text-center p-2 w-24">ステータス<br>更新日</th>
                      </tr>
                    </thead>
                    <tbody v-for="(row, i) in list" :key="i">
                      <tr class="hover-color border border-gray-200" :class="setBgColor(row)">
                        <!-- 報告書No -->
                        <td class="whitespace-nowrap td2 cursor-pointer" @click="toPhotoReport(row)">No. {{ row.id }}</td>

                        <!-- 予定日 -->
                        <td class="whitespace-nowrap text-gray-700 min-w-fit p-2 text-sm cursor-pointer" @click="toPhotoReport(row)">
                          {{ row.day }}
                        </td>

                        <!-- 担当者 -->
                        <td class="font-bold whitespace-nowrap text-sm text-gray-700 min-w-fit p-2 cursor-pointer" @click="toPhotoReport(row)">
                          <div>
                            {{ row.insertUserName }}
                          </div>
                        </td>

                        <!-- 同行詳細 -->
                        <td class="whitespace-nowrap min-w-fit p-2 text-sm cursor-pointer text-green-700" @click="toPhotoReport(row)">
                          {{ row.details }}
                        </td>

                        <!-- 得意先・物件名 -->
                        <td class="whitespace-nowrap cursor-pointer text-gray-700 min-w-fit p-2 text-xs" @click="toPhotoReport(row)">
                          <div>
                            {{ row.clientName }}
                          </div>
                          <div class="mt-1">
                            {{ row.siteName }}
                          </div>
                        </td>

                        <!-- 備考 -->
                        <td class="whitespace-nowrap min-w-fit p-2 text-sm cursor-pointer text-gray-700" @click="toPhotoReport(row)">
                          {{ row.note }}
                        </td>

                        <!-- ステータス -->
                        <td class="whitespace-nowrap text-sm text-gray-700 min-w-fit px-2 py-1 text-center cursor-pointer" @click="toPhotoReport(row)">
                          <div>
                            <Badge :color="statusColor[row.status]">{{ row.status }}</Badge>
                          </div>
                          <div v-if="row.status=='完了'" class="mt-1 font-bold text-xs text-blue-700">
                            {{ row.update }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- 個人結果 -->
              <div v-else-if="tabNo==3">
                <div v-if="list.length" class="rounded-md border border-gray-200 table-h overflow-auto ">
                  <table class="table text-sm w-full">
                    <thead class="th sticky top-0 z-20 bg-colu">
                      <tr class="text-gray-500 text-xs border border-gray-200 bg-colu">
                        <th class="text-left p-2 whitespace-nowrap">対象者（新人）</th>
                        <th class="text-center p-2">完了</th>
                        <th class="text-center p-2">未完了</th>
                        <th class="text-center p-2">合計</th>
                        <th class="text-center p-2"></th>
                      </tr>
                    </thead>
                    <tbody v-for="(row, i) in list" :key="i">
                      <tr class="hover-color border border-gray-200">
                        <!-- 対象者 -->
                        <td class="whitespace-nowrap p-2 cursor-pointer font-bold" @click="toDetail(row)">{{ row.name }}</td>

                        <!-- 完了 -->
                        <td class="whitespace-nowrap text-center p-2 cursor-pointer" @click="toDetail(row)">{{ row.complete }}</td>
                        
                        <!-- 未完了 -->
                        <td class="whitespace-nowrap text-center p-2 cursor-pointer" @click="toDetail(row)">{{ row.unComplete }}</td>
                        
                        <!-- 合計 -->
                        <td class="whitespace-nowrap text-center p-2 cursor-pointer" @click="toDetail(row)">{{ row.total }}</td>
                        
                        <!-- 一覧 -->
                        <td class="whitespace-nowrap text-center p-2 cursor-pointer text-blue-800" @click="toDetail(row)">一覧で確認</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- 項目設定 -->
              <div v-else-if="tabNo==4" class="mx-auto w-fit">
                <div class="flex justify-between">
                  <!-- 並べ替え -->
                  <div class="toggle flex items-center mt-auto mr-5">
                    <span class="mr-1 font-bold text-xs">並べ替え</span>
                    <Toggle v-model="sortable" size="small" />
                  </div>
                  <!-- 追加ボタン -->
                  <PrimaryButton text="項目追加" class="edit-btn" @click="addItem()">
                    <Icon iconName="PlusCircle" slot="before" class="h-4 w-4" />
                  </PrimaryButton>
                </div>

                <table class="table text-sm">
                  <draggable
                    key="reportItem"
                    :list="list"
                    direction="vertical"
                    handle=".row-drag-handle"
                    tag="tbody"
                    class="bg-white divide-y divide-gray-200"
                  >
                    <tr  v-for="(row, i) in list" :key="i" :class="setColor(i)" class="hover-color">
                      <!-- 表示順 -->
                      <td class="td2 text-center">
                        <div v-if="sortable" class="mx-1.5 items-center row-drag-handle cursor-pointer col-no">
                          <MenuIcon class="text-gray-400" />
                        </div>
                        <div v-else>
                          {{ 'No.' + (i + 1) }}
                        </div>
                      </td>

                      <!-- 項目 -->
                      <td class="px-3 py-2">
                        <textarea
                          rows="1"
                          class="border border-gray-300 w-96 my-0.5 rounded"
                          v-model="row.title"
                        />
                      </td>

                      <!-- 削除ボタン -->
                      <td class="td1">
                        <PrimaryButton text="削除" @click="deleteItem(i)" size="normal bg-indigo-200 text-indigo-700 hover:bg-indigo-300" />
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </div>
          <div v-if="!loading && !list.length" class="flex justify-center items-center text-gray-400 -full h-full">
            <EmptyMessage
              iconName="Document"
              message="該当するデータはありません。"
            />
          </div>
          <div class="text-transparent">{{reload}}</div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import EmptyMessage from '@components/EmptyMessage.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Toggle from '@components/Toggle.vue'
import draggable from "vuedraggable"
import Badge from '@components/Badge.vue'
// import DateSelect from '@components/DateSelect.vue'
import { TrashIcon, MenuIcon } from '@vue-hero-icons/solid'
import * as utils from '@libs/utils'
import { AREA_SELECTIONS } from '@libs/constants'
import * as moment from 'moment'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as requestPostManager from '@managers/requestPostManager'
import * as logManager from '@managers/logManager'
import { WEEK_NUM, WEEK_NUM_TO_NAME } from '@libs/constants'

import PageModel from '../../main/pages/PageModel.vue'

// セッションストレージ保存名
const sessionStorageItemName = 'AccompanyCondition'

// ノルマ
const goal = 15

// 切り替え 権限あり
const TABLIST1 = [
        { id: 1, name: '予定組み' },
        { id: 2, name: '一覧' },
        { id: 3, name: '個人結果' },
        { id: 4, name: '項目設定' },
      ]
// 切り替え 権限無し
const TABLIST2 = [
        { id: 2, name: '一覧' },
        { id: 3, name: '個人結果' }
      ]

// イレギュラー枠
const IRREG_FORM = {
        userId: null,
        userName: '',
        departmentId: null,
        departmentName: null,
        schedule: [],
        staffList: [],
        staffList2: []
      }

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    EmptyMessage,
    WmsSuggestInput,
    PrimaryButton,
    TrashIcon,
    MenuIcon,
    draggable,
    Toggle,
    Badge,
    // DateSelect
  },

  props: {
  },

  data() {
    return {
      loading: false,
      // 予定組み、項目設定権限
      auth: false,
      // タブ種類
      tabList: utils.clone(TABLIST1),
      // 選択したタブ
      tabNo: 1,
      // // 表示するデータ
      list: [],
      // 新入社員以外データ作成
      irregFlg: false,
      // イレギュラー枠の予定
      irreg: utils.clone(IRREG_FORM),
      // ノルマ
      goal,
      // 同行者リスト
      staffList: [],
      // 備考リスト
      noteList: [],
      // 本日日付
      today: moment().format('YYYY-MM-DD'),
      // ステータスカラー
      statusColor: {
        '予定': 'green',
        '作成中': 'orange',
        '完了': 'blueGray'
      },
      // 同行報告書マスタデータ
      typeMst: {},
      // 並べ替え
      sortable: false,
      // 検索条件
      filter: {
        // 「更新者が自分」で絞り込み
        filterUpdateUser: true,
        // 報告書No
        id: '',
        // タイトル絞り込み
        title: '',
        // 得意先・物件名絞込み
        clientAndSite: '',
        // 支店・部署絞込み
        office: '',
        // 点検月絞り込み
        implementation: '',
        // 作成者・更新者絞込み
        user: '',
        // 対象者・新人
        newcomer: '',
        // 予定日
        periodScheduled: moment().add(-1, 'Y').format('YYYY-MM-DD'),
        // 更新日        // period: {
        //   start: '',
        //   end: ''
        // },
        // periodPresetName: 'custom',
      },
      reload: 0
    }
  },

  computed: {
    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * タブレット
     */
    isTabletDevice() {
      return utils.deviceInfo.isTablet
    },

    /**
     * カナを削除したログインユーザー名
     */
    loginUser() {
      return utils.deleteKana(this.$store.getters.user.user_name)
    },

    /**
     * 部署リスト
     */
    departmentList() {
      return this.$store.getters.departmentList
    },

    /**
     * 休みの曜日
     */
    getWeek() {
      return (tar) => {
        const res = []
        for (let i = 0; i < WEEK_NUM.length; i++) {
          const w = WEEK_NUM[i]
          if (tar.includes(w.value)) {
            res.push(w.text)
          }
        }
        return ` ※${res.join('・')}曜は休み`
      }
    }
  },

  async created() {
    let auth = this.$store.getters.auth
    // ユーザーのグループ取得
    const g = this.$store.getters.loginUserData
    if ((auth && auth.adminAuth) || (g && g.groupNum && g.groupNum >= 4)) {
      this.auth = true
      this.tabList = utils.clone(TABLIST1)
      this.tabNo = 1
    } else {
      this.auth = false
      this.tabList = utils.clone(TABLIST2)
      this.tabNo = 2
    }
    const area = utils.clone(AREA_SELECTIONS)
    this.noteList = area.map((a) => {
      return { val: a }
    })
    this.getSettionStrage()
    await this.getData()
  },

  methods: {
    /**
     * リフレッシュボタン
     */
    async refresh() {
      await this.getData()
    },

    /**
     * データ取得
     */
    async getData() {
      this.loading = true
      this.list = []
      // 予定組
      if (this.tabNo == 1) {
        const list = await backend.getData('photoReport/accompanySchedule')

        this.staffList = list.data.data.user
        for (let i = 0; i < list.data.data.result.length; i++) {
          const l = list.data.data.result[i]

          // 同行者リスト取得
          l.staffList = this.getStaffList(l)

          let num = this.goal
          if (l.num) {
            num = num - l.saved.length
          }
          if (num) {
            for (let j = 0; j < num; j++) {
              this.addDay(l)              
            }
          }
        }
        this.list = list.data.data.result

      // 一覧
      } else if (this.tabNo == 2) {
        const param = {
          type: [7],
          ...this.filter,
          loginUser: this.loginUser,
          menu: 'accompany'
        }
        const list = await backend.postData('photoReport/getAccompanyList', param)
        if (list.data.data) {
          this.list = list.data.data.list
          this.typeMst = list.data.data.typeMst
        }

      // 個人結果
      } else if (this.tabNo == 3) {
        const list3 = await backend.searchData('photoReport/countAccompanyList', { ...this.filter, loginUser: this.loginUser })
        if (list3.data.data) {
          this.list = list3.data.data
        }

      } else if (this.tabNo == 4) {
        const res = await backend.searchData('photoReport/getCommonItem', { type: 7 })
        if (res.data.data && res.data.data.length) {
          this.list = res.data.data
        } else {
          for (let i = 0; i < 5; i++) {
            this.addItem()
          }
        }
      }
      this.setSessionStorage()
      this.loading = false
    },

    /**
     * 同行者候補リスト
     * @param 対象新人
     */
    getStaffList(row) {
      if (row.departmentId) {
        const res = this.staffList.filter((s) => {
          return s.departmentId == row.departmentId && s.userName != '未定' && row.userName != s.userName
        })
        return res
      }
      return this.staffList
    },

    /**
     * タブ変更
     */
    changeTab(id) {
      this.tabNo = id
      this.getData()
    },

    /**
     * 同行者選択イベント
     */
    staffSelected(e, row, main) {
      if (e) {
        row.seniorId = e.userId
        row.holidayWeeks = e.holidayWeeks
        this.holidayCheck(main.userName, main.holidayWeeks, row)
        if (!row.err) {
          this.holidayCheck(e.userName, e.holidayWeeks, row)
        }
      }
    },

    /**
     * 同行者変更
     */
    staffChange(s) {
      if (!s.senior) {
        s.seniorId = null
        s.holidayWeeks = []
      }
    },

    /**
     * 予定追加
     */
    addDay(row) {
      if (!row.schedule) {
        row.schedule = []
      }
      row.schedule.push({ day: '', senior: '' })
    },

    /**
     * 未完了予定削除
     */
    async deleteRow(s, i, row) {
      const res = await dialogs.showConfirmDialog('削除確認', `${row.userName}さんの ${s.day} の予定を削除してよろしいでしょうか？\r\n紐づく同行メインタスクも削除します。`)
      if (res != 'YES') {
        return
      }
      await backend.deleteData('photoReport/deleteAccompanySchedule', { id: s.id })
      // メインタスクも削除
      await requestPostManager.deleteAccompanyTask(this, { id: s.id })
      row.saved.splice(i, 1)
      this.addDay(row)
      this.reload++
    },

    /**
     * イレギュラー枠の未完了予定削除
     */
    async deleteIrregSavedRow(s, i) {
      const res = await dialogs.showConfirmDialog('削除確認', `${this.irreg.userName}さんの ${s.day} の予定を削除してよろしいでしょうか？\r\n紐づく同行メインタスクも削除します。`)
      if (res != 'YES') {
        return
      }
      await backend.deleteData('photoReport/deleteAccompanySchedule', { id: s.id })
      // メインタスクも削除
      await requestPostManager.deleteAccompanyTask(this, { id: s.id })
      this.irreg.saved.splice(i, 1)
      this.reload++
    },

    /**
     * 保存ボタン
     */
    async save() {
      if (this.tabNo == 1) {
        // 予定日・同行者を設定しているデータのみ取得
        const saveData = []
        for (let i = 0; i < this.list.length; i++) {
          const l = this.list[i]
          if (!l.schedule || !l.schedule.length) {
            continue
          }
          for (let j = 0; j < l.schedule.length; j++) {
            const s = l.schedule[j]
            if (s.day && s.senior) {
              if (!this.checkSameUser(l, s, l.staffList)) {
                return
              }
              if (s.err) {
                if(!window.confirm(`勤務曜日ではない日に予定が組まれていますがよろしいでしょうか？\r\n${l.userName}さんの ${s.day} の予定です。`)) {
                  return
                }
              }
              // 新人
              // saveData.push({ insertUser: l.id, insertUserName: utils.deleteKana(l.userName), scheduledDate: s.day, newcomer: true, pair: utils.deleteKana(s.senior), mainStaff: l.userName, departmentId: l.departmentId, departmentName: l.departmentName })
              // 同行者
              saveData.push({ insertUser: s.seniorId, insertUserName: utils.deleteKana(s.senior), scheduledDate: s.day, newcomerId: l.id, pair: utils.deleteKana(l.userName), mainStaff: s.senior, departmentId: l.departmentId, departmentName: l.departmentName, note: s.note })
            }
          }
        }
        // イレギュラー枠
        if (this.irreg.userId && this.irreg.schedule && this.irreg.schedule.length) {
          if (!this.checkSameIrregUser(this.irreg)) {
            return
          }
          for (let i = 0; i < this.irreg.schedule.length; i++) {
            const s = this.irreg.schedule[i]
            if (s.day && s.senior) {
              if (!this.checkSameUser(this.irreg, s, this.irreg.staffList2)) {
                return
              }
              if (s.err) {
                if(!window.confirm(`勤務曜日ではない日に予定が組まれていますがよろしいでしょうか？\r\n${this.irreg.userName}さんの ${s.day} の予定です。`)) {
                  return
                }
              }
              // 新人
              // saveData.push({ insertUser: this.irreg.userId, insertUserName: utils.deleteKana(this.irreg.userName), scheduledDate: s.day, newcomer: true, pair: utils.deleteKana(s.senior), mainStaff: this.irreg.userName, departmentId: this.irreg.departmentId, departmentName: this.irreg.departmentName })
              // 同行者
              saveData.push({ insertUser: s.seniorId, insertUserName: utils.deleteKana(s.senior), scheduledDate: s.day, newcomerId: this.irreg.userId, pair: utils.deleteKana(this.irreg.userName), mainStaff: s.senior, departmentId: this.irreg.departmentId, departmentName: this.irreg.departmentName, note: s.note })
            }
          }
        }
        if (!saveData.length) {
          alert('保存するデータがありません。')
          return
        }
        const res = await backend.postData('photoReport/newSaveAccompany', { saveData })
        if (res.data.data) {
          // メインタスク登録
          await this.mainTask(res.data.data)
        }

        await dialogs.showSuccessDialog('予定・メインタスク 登録完了', '予定とメインタスクを登録しました。')
        this.irreg = utils.clone(IRREG_FORM)
        await this.getData()

      // 項目設定
      } else if (this.tabNo == 4) {
        // 入力確認
        for (let i = 0; i < this.list.length; i++) {
          const l = this.list[i]
          if (!l.title) {
            await dialogs.showErrorDialog(`No.${(i + 1)} の項目が未入力です。`, '項目を入力するか、削除してください。')
            return false
          }
        }
        try {
          await backend.postData('photoReport/saveCommonItem', { list: this.list, type: 7, insertUser: this.$store.getters.user.id })
          logManager.recordingByRegist(this, false, '同行報告書 項目設定', '同行報告書の固定項目')

          await dialogs.showInfoDialog('保存完了', '保存しました。')
        } catch (error) {
          alert(error)
        }
      }
    },

    /**
     * ユーザーIDとユーザー名が一致しているか確認
     * @param l 対象者
     * @param s 予定レコード
     */
    checkSameUser(l, s, staffList) {
      if (!s.seniorId) {
        alert(`${l.userName}さんの ${s.day} の同行者をドロップダウンから選択してください。\r\n同行者のユーザーIDが取得できていません。`)
        return
      }
      // 選択した同行者とユーザーIDが合致しているか確認
      const staffData = staffList.find((staff) => {
        return staff.userId == s.seniorId
      })
      if (staffData && staffData.userName != s.senior) {
        alert(`${l.userName}さんの ${s.day} の同行者を再度選択してください。\r\n同行者を選択した後に手動で同行者名を変更しないようお願いします。`)
        s.senior = ''
        s.seniorId = ''
        return false
      }
      return true
    },

    /**
     * イレギュラー枠の対象者確認
     */
    checkSameIrregUser(l) {
      // 選択した同行者とユーザーIDが合致しているか確認
      const staffData = l.staffList.find((staff) => {
        return staff.userId == l.userId
      })
      if (staffData && staffData.userName != l.userName) {
        alert(`新入社員ではない、${l.userName}さんの IDが取得できておりません。再度、対象者を選択してください。\r\n選択後、手動で名前を変更しないようお願いします。`)
        return false
      }
      return true
    },

    /**
     * RPメインタスク新規登録
     */
    async mainTask(saveData) {
      for (let i = 0; i < saveData.length; i++) {
        const s = saveData[i]
        let rp = requestPostManager.create()
        rp.type = 'apollo_request_post'
        rp.category2 = ['社内']
        rp.category = ['同行']
        // タイトル
        let day = moment(s.scheduledDate + ' 00:00:00').format('YYYY年MM月DD日')
        rp.inquiry_title = s.insertUserName + '：' + day + ' ' + s.pair.replace('\u3000', '') + ' の同行'
        // 担当者
        rp.toStaffName = s.mainStaff
        rp.toStaffId = String(s.insertUser)
        // 依頼者
        rp.byUser = this.$store.getters.user.user_name
        rp.byUserId = this.$store.getters.user.id
        // 部署
        rp.toDepartment = s.departmentName
        rp.toDepartmentId = s.departmentId
        // 依頼日
        rp.requestDate = moment().format('YYYY-MM-DD')
        // 期限日
        rp.limitDate = s.scheduledDate
        // 期限日が1か月後なら長期タスク
        rp.kubunLimit = utils.getKubunLimit(rp.limitDate)
        // 同行報告書のID
        rp.accompanyId = s.id

        // RPメイン登録
        await requestPostManager.register(this, rp)
      }
    },

    /**
     * 背景色設定
     */
    setColor(i) {
      if (i % 2 != 0) {
        return 'bg-blue'
      }
    },

    /**
     * 削除ボタン イベント
     */
    deleteItem(i) {
      this.list.splice(i, 1)
      if (!this.list || !this.list.length) {
        this.addItem()
      }
    },

    /**
     * 項目追加
     */
    addItem() {
      this.list.push({ item: null })
    },

    /**
     * 対象外設定
     */
    async setNA(row, i) {
      const res = await dialogs.showConfirmDialog('対象外設定', `${row.name}さんは同行予定組みに表示されなくなりますが、よろしいでしょうか？`)
      if (res != 'YES') {
        return
      }
      this.list.splice(i, 1)
    },

    /**
     * 更新日付検索 変更
     */
    periodChange(range, presetName) {
      this.filter.period = range
      this.filter.periodPresetName = presetName
    },

    /**
     * セッションストレージ取得
     */
    getSettionStrage() {
      const searchJson = sessionStorage.getItem(sessionStorageItemName)
      const getItem = JSON.parse(searchJson)
      if (getItem) {
        if (getItem.tabNo) {
          this.tabNo = getItem.tabNo
        }
        this.filter = getItem
      }
    },

    /**
     * セッションストレージ保存
     */
    setSessionStorage() {
      const searchStr = JSON.stringify({ ...this.filter, tabNo: this.tabNo })
      sessionStorage.setItem(sessionStorageItemName, searchStr)
    },

    /**
     * 報告書へ遷移イベント
     */
    toPhotoReport(row) {
      if (this.typeMst) {
        row = utils.photoReportParam(row, this.typeMst)
        row.typeName = this.typeMst.typeName
      }
      this.$router.push({ 
        name: 'PhotoReport',
        params: {
          target: row
        },
        query: {
          id: row.id,
          menu: 'accompany'
        }
      })
    },

    /**
     * 一覧の行カラー
     */
    setBgColor(row) {
      if (row.status == '完了') {
        return 'bg-blue-50'
      }
      let today = Number(moment().format('YYYYMMDD'))
      let sch = Number(row.day.replace(/\//g, ''))
      if (today < sch) {
        return ''
      }
      if (today > sch) {
        return 'bg-red-50'
      }
      if (today == sch) {
        return 'bg-yellow-50'
      }
    },

    /**
     * イレギュラー枠の部署選択
     */
    changeDepartment() {
      const depId = this.irreg.departmentId
      this.irreg.departmentName = this.departmentList.find((dep) => {
        return dep.departmentId == depId
      }).name
      // 該当部署のスタッフ取得
      const sl = this.getStaffList(this.irreg)
      const newUserIds = this.list.map((l) => {
        return l.id
      })
      this.irreg.staffList = sl.filter((s) => {
        return !newUserIds.includes(s.userId)
      })
      if (!this.irreg.staffList || !this.irreg.staffList.length) {
        alert(this.irreg.departmentName + 'に新入社員以外いません。')
        this.irreg.departmentId = null
        this.irreg.departmentName = null
      }
      this.irreg.userId = null
      this.irreg.userName = ''
      this.irreg.holidayWeeks = []
      this.irreg.schedule = []
    },

    /**
     * イレギュラー枠スタッフ選択
     */
    async irregStaffSelected(e) {
      this.irreg.userId = e.userId
      this.irreg.holidayWeeks = e.holidayWeeks
      this.irreg.schedule = []
      for (let i = 0; i < 3; i++) {
        this.irregAddDay()
      }
      this.irreg.staffList2 = this.irreg.staffList.filter((s) => {
        return s.userId != e.userId
      })
      // 未完了の予定を取得
      this.irreg.saved = []
      const list = await backend.searchData('photoReport/accompanyScheduleIrreg', { userId: e.userId, userName: e.userName })
      if (list.data.data.length) {
        this.irreg.saved = list.data.data
      }
      this.reload++
    },

    /**
     * イレギュラー予定追加
     */
    irregAddDay() {
      if (!this.irreg.schedule) {
        this.irreg.schedule = []
      }
      this.irreg.schedule.push({ day: '', senior: '' })
    },

    /**
     * 出勤曜日か確認
     * @param name 名前
     * @param weeks 休み曜日
     * @param tar 対象行データ
     */
    changeDay(name, weeks, tar) {
      // 新人の休み曜日確認
      this.holidayCheck(name, weeks, tar)
      if (!tar.err && tar.senior) {
        // 同行者の休み曜日確認
        this.holidayCheck('同行者の' + tar.senior, tar.holidayWeeks, tar)
      }
    },

    /**
     * 出勤曜日か確認
     * @param name 名前
     * @param weeks 休み曜日
     * @param tar 対象行データ
     */
    holidayCheck(name, weeks, tar) {
      if (weeks && weeks.length && tar.day) {
        const d = (new Date(tar.day)).getDay()
        if (weeks.includes(d)) {
          tar.err = true
          alert(name + 'さんは' + WEEK_NUM_TO_NAME[Number(d)] + '曜日はお休みです。')
          this.reload++
          return
        }
      }
      // 同行者の休み曜日確認
      tar.err = false
      this.reload++
    },

    /**
     * 一覧で確認
     */
    toDetail(row) {
      // 検索条件
      this.filter = {
        // 「更新者が自分」で絞り込み
        filterUpdateUser: false,
        // 報告書No
        id: '',
        // タイトル絞り込み
        title: '',
        // 得意先・物件名絞込み
        clientAndSite: '',
        // 支店・部署絞込み
        office: '',
        // 点検月絞り込み
        implementation: '',
        // 作成者・更新者絞込み
        user: '',
        // 新人
        newcomer: row.name,
        // 予定日
        periodScheduled: '',
      }
      this.changeTab(2)
    }
  },
}
</script>
<style scoped>
.main {
  min-width: 900px;
}

main {
  min-width: 930px;
}

.selecter >>> input[type=text] {
  height: 38px;
}

.bg-colu {
  background: #ebf0fb;
}

.bg-blue {
  background: rgb(243 247 249);
}

.td2 {
  padding-left: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.hover-color:hover {
  background: rgba(163, 231, 228, 0.67) !important;
}
/* 
#filterDate {
  width: auto !important;
}

#filterDate >>> div {
  color: rgb(70, 70, 70) !important;
}

#filterDate >>> input[type=text] {
  background: white !important;
  font-size: small;
}
*/
input::placeholder {
  font-size: small;
}
</style>